import { render, staticRenderFns } from "./detalhes-movimentacao-stock.vue?vue&type=template&id=c4fed39a&scoped=true&"
import script from "./detalhes-movimentacao-stock.vue?vue&type=script&lang=js&"
export * from "./detalhes-movimentacao-stock.vue?vue&type=script&lang=js&"
import style0 from "./detalhes-movimentacao-stock.vue?vue&type=style&index=0&id=c4fed39a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4fed39a",
  null
  
)

export default component.exports